
import { HttpService } from '../common/http/http.service';
import { Path } from "../../../app.config";
import { notificationMessage } from '../../../model/notification/notification.model'; 

export class NotificationService {
    private httpsSrv: HttpService;

    public static $inject: Array<string> = ["HttpService"];
    constructor(httpsService: HttpService) {
        this.httpsSrv = httpsService;
    }

    getNotificationList(category: string) {
        var options = {
            url: Path.APIUrl.GetAllNotificationListUrl(),
            method: "GET",
            params: { Category: category }
        };
        return this.httpsSrv.execute(options);
    }

    getNotificationDetails(notificationId: number) {
        var options = { url: Path.APIUrl.GetNotificationDetails(), params: { notificationId: notificationId } };
        return this.httpsSrv.get(options);
    }

    getNotification(notificationId: number) {
        var options = { url: Path.APIUrl.GetNotification(), params: { notificationId: notificationId } };
        return this.httpsSrv.get(options);
    }

        

    saveNotification(notificationMessage: notificationMessage) {
        var opt = { url: Path.APIUrl.SaveNotificationUrl(), method: "POST", data: { notification: notificationMessage } };
        return this.httpsSrv.execute(opt);
    }

    deleteNotificationDetails(notificationId: number) {
        var options = { url: Path.APIUrl.DeleteNotificationDetails(), method: "POST", data: { NotificationId: notificationId } };
        return this.httpsSrv.execute(options);
    }

    getConflictedAlerts(startDate: Date, endDate: Date, alertId: number) {
        var options = { url: Path.APIUrl.GetConflictedAlerts(), method: "GET", params: { StartDate: startDate, EndDate: endDate, AlertId: alertId } };
        return this.httpsSrv.execute(options);
    }

    getWhatsnewUpdatesAlertsList(title: string, category: string, notificationType: string, duration: string, productType: string) {
        var options = { url: Path.APIUrl.GetWhatsnewUpdatesAlerts(), method: "GET", params: { Title: title, Category: category, NotificationType: notificationType, Duration: duration, ProductType: productType } };
        return this.httpsSrv.execute(options);
    }
    getLoggedInRegion() {
        var options = { url: Path.APIUrl.GetLoggedInRegion(), method: "GET" };
        return this.httpsSrv.execute(options);
    }
    getGoogleTranslationFeature() {
        var opt = { url: Path.APIUrl.getGoogleTranslationFeature() };
        return this.httpsSrv.get(opt);
    }


    getFeatureControlledStatus(parentKey: String, childKey: String) {
        var options = { url: Path.APIUrl.IsFeatureControlled(), method: "GET", params: { parent: parentKey, child: childKey } };
        return this.httpsSrv.execute(options);
    }
    getSupportandResources(resourceTypeCategeory: number) {
        var options = { url: Path.APIUrl.GetAllSupportAndResources(), method: "GET", params: { category: resourceTypeCategeory } };
        return this.httpsSrv.execute(options);
    }
    saveSupportAndResources(tree: any, category: any) {
        var options = { url: Path.APIUrl.SaveSupportAndResources(), method: "POST", data: { list: tree, category: category } };
        return this.httpsSrv.execute(options);
    }
    getWhiteListedURLs() {
        var options = { url: Path.APIUrl.GetWhiteListedURLs(), method: "GET" };
        return this.httpsSrv.execute(options);
    }
}